var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Finals",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.1754 137.8937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #00b3b3;\n      }\n\n      .st1 {\n        fill: #677887;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4553,67.0281c-3.3222.7897-6.1005,3.0646-7.8078,6.0219L7.6599,112.8663c-3.4772,6.024-1.1928,13.7943,5.1446,16.9259,5.7838,2.858,12.8164.4136,16.042-5.1735l12.4652-21.5914,12.6728,21.951c2.2432,3.8859,6.3148,6.0581,10.5006,6.0581h16.1059c2.1672,0,3.5216-2.3463,2.4377-4.223l-31.2275-54.0663c-2.6347-4.5629-7.9885-6.9926-13.3459-5.7191h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.7847,12.8459c-3.3453-5.7944-10.7539-7.7774-16.5455-4.4335-5.793,3.3446-7.7774,10.7525-4.4335,16.5455l43.7819,75.9221c.1658.2875.4724.4646.8043.4646h23.3636c1.7942,0,2.9161-1.9416,2.0202-3.4961L86.7847,12.8459Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.0277,131.1059h-35.0336c-4.3235,0-8.3191-2.3046-10.4839-6.047L48.4098,55.7381c-3.2298-5.5834-1.8369-12.8959,3.526-16.48,5.8776-3.9281,13.7527-2.0294,17.2346,3.9916l36.0823,62.3755c.4499.7777,1.2802,1.2567,2.1787,1.2567h26.1813c6.451,0,12.0839,4.868,12.5009,11.3056.4569,7.0543-5.1298,12.9185-12.0859,12.9185h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodLogo);
export default __webpack_public_path__ + "static/media/cod-logo.6dd842dd5f66b69031d66408bb87ee2b.svg";
export { ForwardRef as ReactComponent };